import { Box, MenuItem as MuiMenuItem, Typography } from '@mui/material'
import { RxCheck } from 'react-icons/rx'
import { tss } from 'tss-react/mui'
import { MenuItemProps } from '../types'
import { getSelectedCheckmarkPrimitives, menuItemPrimitives } from './primitives'

const useStyles = tss.withParams<{ isSelected: boolean }>().create(({ isSelected }) => {
  return {
    menu: menuItemPrimitives,
    checkMark: getSelectedCheckmarkPrimitives(isSelected),
    label: {
      display: 'flex',
      alignItems: 'center',
    },
  }
})

export const DefaultMenuItem = ({
  label,
  className,
  selected,
  showCheckmark,
  children,
  ...rest
}: Omit<MenuItemProps, 'variant'>) => {
  const isSelected = selected || false
  const { cx, classes } = useStyles({ isSelected })
  return (
    <MuiMenuItem className={cx(classes.menu, className)} selected={selected} {...rest}>
      {showCheckmark && (
        <Box className={classes.checkMark}>
          <RxCheck size="14px" />
        </Box>
      )}
      {children ? (
        children
      ) : (
        <Typography className={classes.label} noWrap>
          {label}
        </Typography>
      )}
    </MuiMenuItem>
  )
}
